import React from 'react';
import { getUserStats } from '../services/storage';

const ActivityCalendar = () => {
  const stats = getUserStats();
  
  // Генерируем данные за последние 12 недель (84 дня)
  const weeks = [];
  const today = new Date();
  
  for (let weekIndex = 11; weekIndex >= 0; weekIndex--) {
    const week = [];
    for (let dayIndex = 6; dayIndex >= 0; dayIndex--) {
      const daysAgo = weekIndex * 7 + dayIndex;
      const date = new Date(today);
      date.setDate(date.getDate() - daysAgo);
      const dateStr = date.toISOString().split('T')[0];
      const count = stats.byDate?.[dateStr] || 0;
      
      week.unshift({
        date: dateStr,
        count,
        day: date.getDay()
      });
    }
    weeks.unshift(week);
  }

  const getColor = (count) => {
    if (count === 0) return '#EBEDF0';
    if (count === 1) return '#9BE9A8';
    if (count === 2) return '#40C463';
    if (count === 3) return '#30A14E';
    return '#216E39';
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h3 className="text-sm font-semibold text-gray-900 mb-3 flex items-center">
        <svg className="w-4 h-4 mr-2 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        Календарь активности (последние 12 недель)
      </h3>
      
      <div className="overflow-x-auto">
        <div className="inline-flex gap-1">
          {weeks.map((week, weekIndex) => (
            <div key={weekIndex} className="flex flex-col gap-1">
              {week.map((day, dayIndex) => (
                <div
                  key={dayIndex}
                  className="w-3 h-3 rounded-sm transition-all hover:scale-125 cursor-pointer"
                  style={{ backgroundColor: getColor(day.count) }}
                  title={`${day.date}: ${day.count} восстановлений`}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
      
      <div className="flex items-center justify-between mt-3">
        <span className="text-xs text-gray-500">Меньше</span>
        <div className="flex gap-1">
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: '#EBEDF0' }} />
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: '#9BE9A8' }} />
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: '#40C463' }} />
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: '#30A14E' }} />
          <div className="w-3 h-3 rounded-sm" style={{ backgroundColor: '#216E39' }} />
        </div>
        <span className="text-xs text-gray-500">Больше</span>
      </div>
    </div>
  );
};

export default ActivityCalendar;











